import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Swiper from 'swiper';


let initPodcastsSlider = () => {
  const swiperNews = new Swiper('.podcasts-slider > .swiper-container', {
    modules: [Navigation, Autoplay, Pagination],
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: false,
    spaceBetween: 25,
    slideToClickedSlide: false,
    navigation: {
      nextEl: '.podcasts-slider__next',
      prevEl: '.podcasts-slider__prev',
    },
    dynamicBullets: true,
    pagination: {
      el: '.podcasts-slider__pagination',
      type: 'fraction',
      clickable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      1023: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 45,
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initPodcastsSlider);
